var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"protocol h-752px"},[_c('div',{staticClass:"main overflow-hidden px-53px bg-white text-19px flex flex-col",staticStyle:{"color":"#333"}},[_c('div',{staticClass:"h-full overflow-y-auto",domProps:{"innerHTML":_vm._s(_vm.html)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }